export const withBase = path => {
  const base = process.env.PUBLIC_URL;

  // normalize input
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};
